module.exports = __webpack_public_path__ + "img/experience--xxl.576b0767.jpg";